export default __webpack_public_path__ + "static/media/down_big_arrow_icon.a5d5c90a.svg";